// extracted by mini-css-extract-plugin
export default {"carousel":"style_carousel__URuQF"};